var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8791 9.28168L8.39309 14.9083C7.56709 15.7555 7.56709 17.1299 8.39309 17.9771V17.9771C9.21909 18.8242 10.5591 18.8242 11.3851 17.9771L18.6171 10.5596C20.1321 9.00578 20.1321 6.48681 18.6171 4.93296V4.93296C17.1021 3.37912 14.6461 3.37912 13.1311 4.93296L5.89909 12.3504C3.69509 14.6109 3.69509 18.2745 5.89909 20.535V20.535C8.10309 22.7955 11.6751 22.7955 13.8791 20.535L18.2681 16.0335",
    stroke: "#000F30",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendFile);
export default __webpack_public_path__ + "static/media/SendFile.bf40c627699a89668fdcce4669dddab7.svg";
export { ForwardRef as ReactComponent };